// Production (PR1) environment — Angular build-time configuration.
//
// Wartosci tutaj sa zaszywane w bundle przez `ng build --configuration=production`
// (frontend) oraz odczytywane przez SSR server (backend Express w tym samym podzie).
//
// SEKRETY (passwords, API keys, tokens) NIE sa tu — czytane z `process.env`
// w runtime'ie (External Secrets Operator -> Kubernetes Secret -> envFrom).
// Patrz README.md sekcja "Sekrety / Env vars".

export const environment = {
  // Publiczne URL-e (bezpieczne w bundle)
  //
  // baseUrl = publiczny host produkcyjny (canonical/SEO, magic-linki w SMS/mailu).
  // Po cutoverze domeny app serwowany na drzewowisni.pl / www / pr1.aws,
  // ale kanoniczny URL ZAWSZE wskazuje apex drzewowisni.pl.
  baseUrl: 'https://drzewowisni.pl',

  // apiUrl — same-origin, platform-aware (rozwiazuje CORS po cutoverze domeny):
  //  - BROWSER: relative '/api' -> dziala na KAZDYM hoscie (drzewowisni.pl/api,
  //    www.../api, pr1.aws/api) -> ALB -> ten sam pod. Zero CORS, zero zaleznosci
  //    od konkretnego hosta.
  //  - SSR (Node, brak `window`): relative URL NIE dziala server-side (fetch
  //    potrzebuje absolutnego), a Express API jest w TYM SAMYM podzie ->
  //    wolamy bezposrednio loopback http://localhost:${PORT}/api (PORT default 4000).
  // Getter zwraca string, wiec konsumenci `environment.apiUrl + '/x'` dzialaja bez zmian.
  get apiUrl(): string {
    if (typeof window !== 'undefined') {
      return '/api';
    }
    const port =
      (typeof process !== 'undefined' && process.env && process.env['PORT']) ||
      '4000';
    return `http://localhost:${port}/api`;
  },

  // assetsUrl — origin dla SSR-side fetchy assetow statycznych (i18n JSON itp.),
  // platform-aware, ten sam wzorzec co apiUrl (rozwiazuje hairpin self-fetch):
  //  - BROWSER: '' -> konsument buduje relative '/assets/...' -> same-origin,
  //    dziala na KAZDYM hoscie (drzewowisni.pl / www / pr1.aws). Zero hairpin.
  //  - SSR (Node, brak `window`): Angular SSR HttpClient absolutyzuje relative URL
  //    domena ZADANIA (https://drzewowisni.pl) -> pod w prywatnym subnecie strzela
  //    do internet-facing ALB -> hairpin -> status 0 "Unknown Error".
  //    Dlatego prefiksujemy loopbackiem http://localhost:${PORT} — ten sam pod
  //    serwuje /assets przez express.static (server.ts). PORT default 4000.
  // Konsument: app.module.ts (TRANSLATE_HTTP_LOADER_CONFIG.prefix).
  get assetsUrl(): string {
    if (typeof window !== 'undefined') {
      return '';
    }
    const port =
      (typeof process !== 'undefined' && process.env && process.env['PORT']) ||
      '4000';
    return `http://localhost:${port}`;
  },

  // Tag manager (publiczny ID)
  googleTagManagerId: 'GTM-P6PGFK4',

  // Cron scheduler — w PROD env ON (reminder maili, GoPOS sync, daily summary).
  schedulerEnabled: true,

  // Production flag — secure cookies, Service Worker, optymalizacje Angular.
  production: true,

  // Listy adresatow biznesowych — non-secret, edytowalne build-time.
  reservationsSummaryEmailAddresses: [
    'katarzyna.wujczak@datasystempl.onmicrosoft.com',
    'tomasz.waligora@icloud.com',
    'rezerwacje@drzewowisni.pl'
  ],
  reservationEmailAddresses: ['tomasz.waligora@icloud.com', 'rezerwacje@drzewowisni.pl'],
  reservationSMSAddresses: [],
  reservationVehicleEmailAddress: ['tomasz.waligora@icloud.com'],
  overdueTasksEmail: ['tomasz.waligora@icloud.com', 'rezerwacje@drzewowisni.pl'],

  // GoPOS — organization ID jest publiczne, client_id/secret z process.env.
  goposOrganization: '1796',
  goposUrl: 'https://app.gopos.io/'
};
